import type { WordCloudCircle } from 'functions/general/getCircles';
import type { LocalStorageFunctions, LocalWordCloud } from './types';

const WORD_CLOUD: string = 'word-cloud';

const getLocalStorageWordCloud = (fn: LocalStorageFunctions) => (documentId: string) => {
  const choice = fn.readObject<Record<string, string>>(WORD_CLOUD);
  if (!choice?.[documentId]) return undefined;
  return JSON.parse(choice[documentId]) as WordCloudCircle[];
};

const setLocalStorageWordCloud = (fn: LocalStorageFunctions) => (data: string, documentId: string) => {
  let choice = fn.readObject<Record<string, string>>(WORD_CLOUD);
  if (!choice) {
    choice = {};
  }
  choice[documentId] = data;
  fn.writeObject(WORD_CLOUD, choice);
};

const delLocalStorageWordCloud = (fn: LocalStorageFunctions) => (documentId: string) => {
  const choice = fn.readObject<Record<string, string>>(WORD_CLOUD);
  if (!choice?.[documentId]) return;
  delete choice[documentId];
  fn.writeObject(WORD_CLOUD, choice);
};

const wordCloud = (fn: LocalStorageFunctions): LocalWordCloud => ({
  getLocalStorageWordCloud: getLocalStorageWordCloud(fn),
  setLocalStorageWordCloud: setLocalStorageWordCloud(fn),
  delLocalStorageWordCloud: delLocalStorageWordCloud(fn)
});

export default wordCloud;
